import useStore from './useStore';
import { BASIC_MODE_ECOM_PLATFORM } from 'dictionary';

export default function useRetailerMode() {
  const { ecomPlatform } = useStore();

  const isBasicMode = ecomPlatform === BASIC_MODE_ECOM_PLATFORM;

  return {
    isBasicMode,
    isAdvancedMode: !isBasicMode
  };
}
